import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectMemberMarketMaker: "selectMemberMarketMaker [Action]",
  selectMemberMarketMakerLoading: "selectMemberMarketMakerLoading [Action]",
  selectMemberMarketMakerAsync: "selectMemberMarketMakerAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_member_market_maker_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectMemberMarketMaker:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.selectMemberMarketMakerLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectMemberMarketMakerLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "market_maker",
    method_type: "select_member_market_maker",
    data: payload?.data ? payload.data : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectMemberMarketMaker,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectMemberMarketMakerLoading,
      payload: false,
    });
  }
}

export function* selectMemberMarketMaker() {
  yield takeLatest(actionTypes.selectMemberMarketMakerAsync, handleWorker);
}
